export const specials = [
  {
    id: "midnight-tokyo",
    title: "深夜东京 · 霓虹情事",
    subtitle: "Midnight Tokyo",
    cover: "crimsonCurtain",
    banner: "tokyoNight",
    curator: "编辑组 · 夜行档案",
    updatedAt: "2026-09-28",
    intro:
      "把镜头交给凌晨零点之后的城市。本期专题收录十部以雨夜、霓虹与末班车为背景的作品，从新宿的窄巷到跨江大桥，记录那些只在深夜发生的关系。",
    workIds: [
      "night-tokyo",
      "neon-never-sleeps",
      "city-night-walker",
      "seoul-midnight-bus",
      "the-follower",
      "midnight-call",
      "overtime-until-three",
      "confession-after-rain",
      "december-train",
      "the-last-night",
    ],
  },
  {
    id: "urban-lonely",
    title: "都市夜归人 · 城市情感档案",
    subtitle: "Urban Loneliness",
    cover: "rooftopDusk",
    banner: "citySuite",
    curator: "编辑组 · 都会观察",
    updatedAt: "2026-08-16",
    intro:
      "合租、加班、末班电梯与便利店夜班——当代都市人的亲密关系往往从这些不起眼的缝隙里长出来。十部作品，十种在城市里不孤单的方式。",
    workIds: [
      "roommate",
      "thirty-seconds-in-elevator",
      "wind-on-the-roof",
      "seventh-floor-office",
      "afternoon-of-married-woman",
      "double-bed",
      "neighbor-sister-secret",
      "convenience-night-shift",
      "perfume-and-smoke",
      "bangkok-heatwave",
    ],
  },
  {
    id: "oriental-dream",
    title: "东方绮梦 · 古装美学特辑",
    subtitle: "Oriental Dream",
    cover: "moonGarden",
    banner: "palaceNight",
    curator: "编辑组 · 古典选片",
    updatedAt: "2026-07-04",
    intro:
      "烛火、回廊、绢本与和服。本期专题从服化道与构图出发，挑选十部在东方古典语境中完成叙事的作品，看看克制如何比直白更有力量。",
    workIds: [
      "dream-of-long-night",
      "spring-palace-chronicle",
      "courtesan-tale",
      "deep-palace-grudge",
      "red-thread",
      "jiangnan-rain",
      "generals-banquet",
      "listening-rain-in-corridor",
      "golden-house-dream",
      "changan-under-moon",
    ],
  },
];